module.exports = __webpack_public_path__ + "static/media/banner.ce6f901f.jpg";